import { useReducer, useDebugValue } from 'react';
import { trialStatusInit, ACTIONS } from './constants';

function trialStatusReducer(state, action) {
    switch (action.type) {
        case ACTIONS.SET_STATUS_PENDING: {
            return {
                ...state,
                status: 'PENDING',
                colorScheme: '#D69E2E',
                tooltipText: 'Customer Status: PENDING APPROVAL',
            };
        }
        case ACTIONS.SET_STATUS_LIVE: {
            return {
                ...state,
                status: 'LIVE',
                colorScheme: '#38A169',
                tooltipText: 'Customer Status: LIVE',
            };
        }
        case ACTIONS.SET_STATUS_TRIAL: {
            return {
                ...state,
                status: 'TRIAL',
                colorScheme: '#007BFF',
                tooltipText: 'Customer Status: TRIAL',
            };
        }
        case ACTIONS.SET_STATUS_HOLD: {
            return {
                ...state,
                status: 'HOLD',
                colorScheme: '#FFFFFF',
                tooltipText: 'Customer Status: TRIAL EXPIRED',
            };
        }
        case ACTIONS.SET_STATUS_DISABLED: {
            return {
                ...state,
                status: 'DISABLED',
                colorScheme: '#FFFFFF',
                tooltipText: 'Customer Status: DISABLED',
            };
        }

        default: {
            return {
                ...state,
                status: 'HOLD',
                colorScheme: '#FFFFFF',
                tooltipText: 'Customer Status: TRIAL EXPIRED',
            };
        }
    }
}

export function useTrialStatus() {
    const [trialStatus, setTrialStatus] = useReducer(
        trialStatusReducer,
        trialStatusInit,
    );

    useDebugValue(
        trialStatus.status === 'NA' ? 'No trial status' : trialStatus.status,
    );

    return { trialStatus, setTrialStatus };
}
